<template>
    <ModelEditLayout
        :indexRoute="$route('admin::realtors.index')"
        :updateRoute="$route('admin::realtors.update', { realtor: realtor.id })"
        :modelNameSingular="__('admin::realtors.realtor')"
        :modelNamePlural="__('admin::realtors.realtors')"
        :form="form"
        :name="form.name"
    >

        <FormGroup :label="__('admin::labels.name')" :error="errors.name">
            <Input name="name" type="text" :has-error="exists(errors.name)" v-model="form.name" :required="true" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.title')" :error="errors.title">
            <Input name="title" type="text" :has-error="exists(errors.title)" v-model="form.title" :required="true" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.email')" :error="errors.email">
            <Input name="email" type="email" :has-error="exists(errors.email)" v-model="form.email" :required="false" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.phone')" :error="errors.phone">
            <Input name="phone" type="text" :has-error="exists(errors.phone)" v-model="form.phone" :required="false" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.image')" :error="errors.image">
            <div class="relative w-48 h-48 rounded-md" v-if="! showImageInput">
                <img class="w-full h-full rounded-md object-cover" :src="realtor.public_path" alt="" />
                <button type="button" class="w-full absolute bottom-0 left-0 text-center p-2 bg-white/20 text-black text-sm uppercase font-bold rounded-b-md" @click="showImageInput = true">
                    {{ __('admin::labels.change') }}
                </button>
            </div>
            <FileInput name="image" :has-error="exists(errors.image)" v-model="form.image" :required="false" v-if="showImageInput" />
        </FormGroup>

    </ModelEditLayout>
</template>

<script>
    import ModelEditLayout from '@/Layouts/ModelEditLayout'
    import FormGroup from "@/Components/FormGroup";
    import Input from "@/Components/Input";
    import FileInput from "@/Components/FileInput";

    export default {
        components: {
            FileInput,
            Input,
            FormGroup,
            ModelEditLayout,
        },
        props: {
            errors: Object,
            realtor: Object,
        },
        data() {
            return {
                form: this.$inertia.form({
                    name: this.realtor.name,
                    title: this.realtor.title,
                    email: this.realtor.email,
                    phone: this.realtor.phone,
                    image: null,
                }),
                showImageInput: !this.realtor.image_path,
            }
        },
    }
</script>
